import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XpoLtlBaseCacheService } from '@xpo-ltl/ngx-ltl';
import { ClaimsApiService, ListExaminerActiveClosedClaimsResp, ListExaminerActiveClosedClaimsQuery } from '@xpo-ltl/sdk-claims';
import * as _ from 'lodash';
import { AssignedActiveClosedCacheParams } from '../../interfaces/assigned-active-closed-cache-params.interface';
import { ApiRequest } from '@xpo-ltl/data-api';

@Injectable()
export class ListExaminerActiveClosedCacheService extends XpoLtlBaseCacheService<AssignedActiveClosedCacheParams, ListExaminerActiveClosedClaimsResp> {
  constructor(private claimsApiService: ClaimsApiService) {
    super();
  }

  protected getKeyFromParams(params: AssignedActiveClosedCacheParams): string {
    return `${params.index}`;
  }

  protected requestData(params: AssignedActiveClosedCacheParams): Observable<ListExaminerActiveClosedClaimsResp> {
    const request = new ListExaminerActiveClosedClaimsQuery();
    _.assign(request, _.pick(params, _.keys(request)));
    request.examinerEmployeeId = params.employeeId;

    return this.claimsApiService.listExaminerActiveClosedClaims(request, { ...ApiRequest.defaultDataOptions, toastOnError: false });
  }
}
